export default __webpack_public_path__ + "static/866-37c4b9c49b1626403dd1b76f5a9f650f.gif";